import { useSelector } from "react-redux"
import { useState, useEffect } from "react";
import { LocalNetworkResultType } from "../../../../models/local-network.model"
import { RootState, useAppDispatch } from "../../../../redux/store"
import { retrieveLocalNetwork } from "../../../../redux/slice/local-network.slice";

const ChapterLNGListingGrid = () => {
  const dispatch = useAppDispatch();
  const { response } = useSelector((state: RootState) => state.localNetwork);
  const [formattedData, setFormattedData] = useState([[] as LocalNetworkResultType[]]);

  const folderPath = "%2FMembership%2FChapters-Local-Networks%2FTable-Links"
  const numberOfColumns = 4;

  useEffect(() => {
    dispatch(retrieveLocalNetwork(folderPath));
  }, [dispatch]);

  useEffect(() => {
    if (response && response.result && response.result.length > 0) {
      let data = [] as LocalNetworkResultType[][]; //Store currentData once number of items has reached number of columns
      let currentData = [] as LocalNetworkResultType[]; //Store items based on number of columns
      let currentColumnNumber = 1;

      response.result.map((item) => {
        if (currentColumnNumber < 4) {
          currentData.push(item);

        } else {
          currentData.push(item);
          data.push(currentData);
          currentData = [] as LocalNetworkResultType[];
          currentColumnNumber = 0;
        }

        currentColumnNumber++;
      });

      if (currentData.length !== 0) {
        for (let i = currentData.length + 1; i <= numberOfColumns; i++)
          currentData.push({} as LocalNetworkResultType);

        data.push(currentData);
      }

      setFormattedData(data);
    }
  }, [response]);

  function RenderRowData(rowItems: LocalNetworkResultType[], index: number) {
    return (
      <>
        {rowItems.map((item) => {
          const forumTitle = item.netWorksTitle?.replace("Chapter", "(C)")?.replace("Local Networking Group", "(L)")
          return (<div className="col-3" key={item.netWorksTitle} data-region={item.netWorksRegion}>
            <a href={item.netWorksLink} target={item.netWorkNewWindow ? "_blank" : undefined} rel={item.netWorkNewWindow ? "noopener noreferrer" : undefined}>
              {forumTitle}
            </a>
          </div>);
        })}
      </>
    );
  }

  return (
    <div className="container-fluid mb-4 pb-2" style={{ backgroundColor: "#8CC7F9" }} >
      <div className="container">
        <div className="tabs tabs-responsive">
          <div className="table-responsive-off mb-dropdown-table-off">
            {/*<div className="mb-dropdown-table-btn">Chapters &amp; Local Networks</div>*/}
            <div className="row justify-content-center listing" style={{ backgroundColor: "#FFF" }}>
              {formattedData.map((item, index) => {
                return RenderRowData(item, index);
              })}
            </div>
            <p className="text-center legend my-4"><b>Legend:</b><br /> (C) = Chapter | (L) = Local Networking Group</p>
            {/*<table>
            <tbody>
              {formattedData.map((item, index) => {
                return RenderRowData(item, index);
              })}
            </tbody>
          </table>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterLNGListingGrid;